import { BulmaMessage } from 'components/Bulma'
import supportedBrowsers from '../supportedBrowsers'

const isBuildTime = typeof window === 'undefined'

const BrowserOutOfDateWarning = () => {
  if (isBuildTime) {
    return null
  }

  const isBrowserSupported = supportedBrowsers.test(navigator.userAgent)

  if (isBrowserSupported) {
    return null
  }

  return (
    <BulmaMessage color="danger">
      <p>
        You're using an out of date browser which we don't support. This might cause problems with your registration.
      </p>
      <p className="mt-3">
        We encourage you to update your browser to a more recent version for a successful registration.
      </p>
    </BulmaMessage>
  )
}

export default BrowserOutOfDateWarning
